import { gql } from '@apollo/client';

export const GET_DEPOSIT_DATA = gql`
  query getDeposit($id: Int) {
    getWorkShiftPaymentOverviewData(id: $id) {
      bonus
      deposit
    }
  }
`;
